import { getObjectValueByPath } from 'vuetify/lib/util/helpers'

export default {
  getValue (obj, path, fallback) {
    return getObjectValueByPath(obj, path, fallback)
  }
}
